export default __webpack_public_path__ + "static/media/work6.51537248.png";